// src/pages/NotFoundPage.jsx
import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { trackMetric } from '../services/telemetryService';

/**
 * Página 404 (No Encontrada) temática de Xolo Fest 2026.
 * Integra la identidad rojinegra del Club Tijuana Xolos,
 * botones de regreso al inicio, registro y recuperación de pases.
 */
export default function NotFoundPage() {
  useEffect(() => {
    trackMetric('page_view', { page: '404', path: window.location.pathname });
  }, []);

  return (
    <div
      className="not-found-page-wrapper py-5 d-flex align-items-center justify-content-center"
      style={{ minHeight: '80vh', background: 'transparent' }}
    >
      <div className="container text-center py-4 position-relative" style={{ zIndex: 1 }}>
        {/* Logo Oficial Xolo Fest */}
        <div className="d-flex justify-content-center mb-4">
          <Link to="/" title="Ir a inicio">
            <img
              src="/img/brand/logo-xolofest-vertical.png"
              alt="Xolo Fest 2026"
              style={{
                maxHeight: '90px',
                width: 'auto',
                objectFit: 'contain',
                filter: 'drop-shadow(0 8px 20px rgba(0, 0, 0, 0.75))'
              }}
            />
          </Link>
        </div>

        {/* Tarjeta Central 404 */}
        <div className="row justify-content-center">
          <div className="col-12 col-md-9 col-lg-7 col-xl-6">
            <div
              className="p-4 p-md-5 rounded-4 shadow-2xl text-light"
              style={{
                backgroundColor: 'rgba(17, 17, 22, 0.95)',
                border: '1px solid rgba(220, 38, 38, 0.35)',
                backdropFilter: 'blur(10px)'
              }}
            >
              {/* Número 404 con estilo rojinegro */}
              <div
                className="display-1 fw-black text-danger font-monospace mb-2"
                style={{
                  letterSpacing: '2px',
                  textShadow: '0 0 30px rgba(220, 38, 38, 0.6), 0 4px 14px rgba(0, 0, 0, 0.9)'
                }}
              >
                404
              </div>

              {/* Título Temático */}
              <h1 className="h3 fw-bold text-white mb-3">
                ¡Fuera de Lugar!
              </h1>

              {/* Descripción */}
              <p className="text-light opacity-90 mb-4 mx-auto" style={{ maxWidth: '440px', lineHeight: 1.6 }}>
                La jugada no prosperó. La página que buscas no existe, cambió de dirección o el enlace es incorrecto.
              </p>

              {/* Acciones principales */}
              <div className="d-flex flex-column flex-sm-row justify-content-center gap-3 mb-4">
                <Link
                  to="/"
                  className="btn btn-xolo-primary px-4 py-2 fw-bold d-inline-flex align-items-center justify-content-center gap-2"
                >
                  <i className="bi bi-house-door-fill"></i>
                  <span>Volver al Inicio</span>
                </Link>

                <Link
                  to="/r"
                  className="btn btn-outline-light px-4 py-2 fw-semibold d-inline-flex align-items-center justify-content-center gap-2"
                >
                  <i className="bi bi-ticket-perforated-fill text-danger"></i>
                  <span>Registrar Boleto</span>
                </Link>
              </div>

              {/* Enlace secundario de recuperación con alta legibilidad */}
              <div className="pt-3 border-top border-secondary border-opacity-25 small">
                <span className="text-light opacity-90 me-2">¿Buscabas tus pases digitales?</span>
                <Link
                  to="/r/recuperar"
                  className="text-danger fw-bold text-decoration-none"
                >
                  Consúltalos aquí <i className="bi bi-arrow-right"></i>
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
